export const INTEGRATIONS = {
    DISABLED: 'DISABLED',
    CAF: 'CAF',
    XPOINT: 'XPOINT',
    XPOINT_LITE: 'XPOINT_LITE',
    XPOINT_NATIVE: 'XPOINT_NATIVE'
};

export enum GEOLOCATION_REASON {
    INITIAL_CHECK = 'INITIAL_CHECK',
    INTERVAL_CHECK = 'INTERVAL_CHECK',
    IP_CHANGE_CHECK = 'IP_CHANGE_CHECK',
    RECONNECT_CHECK = 'RECONNECT_CHECK',
    ACL_RULE_FAILURE_CHECK = 'ACL_RULE_FAILURE_CHECK',
    FOREGROUND_CHECK = 'FOREGROUND_CHECK',
    UNDEFINED = 'UNDEFINED'
}
